import { assertContext } from '@helpers'
import { useContext } from 'react'
import { ConversationContext } from '../contexts'

export const useConversationContext = () => {
  const context = useContext(ConversationContext)

  return assertContext(
    context,
    'useConversationContext',
    'ConversationContextProvider'
  )
}
